import React, { useState, useRef, type KeyboardEvent } from "react";
import { Button, IconFa, Text } from "@cruk/cruk-react-components";
import { faCopy } from "@fortawesome/free-regular-svg-icons";

import { isBrowser } from "@fwa/src/utils/browserUtils";

import styles from "./styles.module.css";
import sharedStyles from "@fwa/src/components/styles.module.css";

export function CopyToClipBoard({
  shareCopy,
  onClick,
}: {
  shareCopy: string;
  onClick?: () => void;
}) {
  const [copyMessage, setCopyMessage] = useState<string | null>(null);
  const ref = useRef<HTMLInputElement | null>(null);

  const copyToClipboard = () => {
    if (!isBrowser) return;
    if (ref.current) {
      ref.current.select();
      ref.current.setSelectionRange(0, 99999);
    }
    const copySuccess = document.execCommand("copy");
    if (copySuccess) {
      setCopyMessage(`Copied to clipboard`);
    } else {
      setCopyMessage("Select text to copy");
    }
    setTimeout(() => {
      setCopyMessage(null);
    }, 2000);
    if (onClick) {
      onClick();
    }
  };

  function handleInputClick(e: React.MouseEvent<HTMLInputElement>) {
    e.currentTarget.select();
    e.currentTarget.setSelectionRange(0, 99999);
  }

  return (
    <span
      className={styles["copy-text-wrapper"]}
      style={{ position: "relative" }}
      data-component="copy-clipboard"
    >
      {copyMessage?.length ? (
        <div className={styles["copy-message"]}>
          <Text textAlign="center">{copyMessage}</Text>
        </div>
      ) : null}
      <input
        type="text"
        aria-label="copy url"
        name="share-url"
        readOnly
        ref={ref}
        value={shareCopy}
        onClick={handleInputClick}
      />
      <Button
        className={["component-button", styles["copy-button"]].join(" ")}
        appearance="secondary"
        onClick={() => {
          copyToClipboard();
        }}
        onKeyDown={(e: KeyboardEvent<HTMLButtonElement>) => {
          if (e.key === "Enter") copyToClipboard();
        }}
        aria-label="copy url"
        role="button"
        tabIndex={0}
        data-cta-type="share-copy-clipboard"
      >
        <div className={sharedStyles["row-align-center"]}>
          <IconFa faIcon={faCopy} size="1.5rem" />
          <span className={styles["button-text"]}>Copy</span>
        </div>
      </Button>
    </span>
  );
}

export default CopyToClipBoard;
